module.exports = __webpack_public_path__ + "img/001-linkedin.c0c32ea6.svg";